// extracted by mini-css-extract-plugin
module.exports = {"phoneInput":"PhoneInput_phoneInput__3z-LT","phoneInputWrapper":"PhoneInput_phoneInputWrapper__38YNo","label":"PhoneInput_label__1kNE3","required":"PhoneInput_required__31kRQ"};